export const formatCurrency = (value?: number): string => {
  if (value === undefined || value === null) {
    value = 0;
  }

  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

export const formatCents = (cents?: number): string => {
  if (cents === undefined || cents === 0) {
    return formatCurrency(0)
  }

  return formatCurrency(Math.ceil(cents / 100))
}
